module.exports = __webpack_public_path__ + "static/media/nasaLogo.e5dda912.png";